module.exports = __webpack_public_path__ + "img/ico-search.a784ef3e.svg";